module.exports = __webpack_public_path__ + "static/media/5.54b1917a.jpg";